module.exports = "\n<div>\n\t<img style=\"position:absolute; top:0; left:0; right:0; bottom:0; margin:auto;\" src=\"assets/images/comingsoon.jpg\" class=\"img img-responsive\" alt=\"Coming soon\">\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/notavailable.html
// module id = 304
// module chunks = 0